import { IconSvgProps } from "./types";

export const ClosedLock = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        id="icon-object-closedlock"
        viewBox="0 0 22 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12H0V28H22V12L19 12V8C19 3.58172 15.4183 0 11 0C6.58172 0 3 3.58172 3 8L3 12ZM7 12V8C7 5.79086 8.79086 4 11 4C13.2091 4 15 5.79086 15 8V12L7 12Z"
            fill="#1868DB"
        />
    </svg>
);
